import { c as _c } from "react/compiler-runtime";
import { MultiTraitTooltip } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { TextOverflowTooltip } from "@opensea/ui-kit";
import { useIsMultiTraitOfferEnabled } from "@/hooks/use-flags";
import { ActivityEventFragment } from "./ActivityEvent.fragment";
export function ActivityEventDescription(t0) {
  const $ = _c(6);
  const {
    activity: activityKey
  } = t0;
  let t1;
  if ($[0] !== activityKey) {
    t1 = readFragment(ActivityEventFragment, activityKey);
    $[0] = activityKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activity = t1;
  const isMultipleTraitOfferEnabled = useIsMultiTraitOfferEnabled();
  switch (activity.type) {
    case "TRAIT_OFFER":
      {
        if (activity.__typename !== "TraitOffer") {
          return null;
        }
        const {
          traitIdentifiers
        } = activity;
        if (!traitIdentifiers || traitIdentifiers.length === 0) {
          return null;
        }
        if (isMultipleTraitOfferEnabled && traitIdentifiers.length > 1) {
          let t2;
          if ($[2] !== traitIdentifiers) {
            t2 = <MultiTraitTooltip traits={traitIdentifiers} />;
            $[2] = traitIdentifiers;
            $[3] = t2;
          } else {
            t2 = $[3];
          }
          return t2;
        }
        const firstTrait = traitIdentifiers[0];
        const text = `${firstTrait.traitType}: ${firstTrait.value}`;
        let t2;
        if ($[4] !== text) {
          t2 = <TextOverflowTooltip className="w-[110px]" content={text}>{text}</TextOverflowTooltip>;
          $[4] = text;
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        return t2;
      }
    default:
      {
        return null;
      }
  }
}